export default __webpack_public_path__ + "static/media/spiderman-img-2.9aea5c21.gif";